import store, { history } from './store'

const init = () => {
  return {
    store,
    history
  }
}

export default init
